import React from 'react';
import ProfileSection from '../Settings_new/Profile/ProfileSection';
import CompanySection from '../Settings_new/Company/CompanySection';
import { Box, Grid } from '@mui/material';



function Settingsmain() {
    return (
        <Box
            sx={{
                pt: { xs: 2, md: 3 },
                pb: 2,
            }}
        >
        <Grid container spacing={2}>
            {/* Left Section */}
            <Grid item xs={3.5}>
                <ProfileSection />
            </Grid>

            {/* Right Section */}
            <Grid item xs={8.5}>
                <CompanySection />
            </Grid>
        </Grid>
        </Box>
    );
}

export default Settingsmain;
